<template lang="pug">
  .gw-nav
    MyGamesCookies(v-if="show_cookies_policy", @setCookie="setCookie")
    MyGamesHeadline(v-if="!onlyCookies", :hideNavigation="hideNavigation",  :hideLogo="hideLogo", :userLinks="userLinks", :headerBGColor="headerBGColor", :headerTextColor="headerTextColor", :promoName="promoName", :showFullLanguages="showFullLanguages")

</template>
<script>
import Cookies from "js-cookie";
import MyGamesCookies from "./MyGamesCookies.vue";
import MyGamesHeadline from "./MyGamesHeadline.vue";

export default {
  name: "MyGamesHeader",

  components: {
    MyGamesCookies,
    MyGamesHeadline,
  },

  props: {
    onlyCookies: {
      type: Boolean,
      required: false,
      default: false,
    },
    userLinks: {
      type: Array,
      required: true,
    },
    headerBGColor: {
      type: String,
      required: false,
    },
    headerTextColor: {
      type: String,
      required: false,
    },
    promoName: {
      type: String,
      required: false,
    },
    showFullLanguages: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideNavigation: {
      type: Boolean,
      default: false,
    },
    hideLogo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cookie_name: "cacc",
      cookie_days: 10000,
      show_cookies_policy: false,
    };
  },

  mounted() {
    this.checkForCookie();
  },

  methods: {
    checkForCookie() {
      if (!Cookies.get(this.cookie_name)) {
        this.show_cookies_policy =
          typeof window.APP_ENV.show_cookies === "boolean" ? window.APP_ENV.show_cookies : true;
      }
    },
    setCookie() {
      const cookie_host = window.location.host;

      Cookies.set(this.cookie_name, 1, {
        path: "/",
        domain: cookie_host,
        expires: this.cookie_days,
      });
      this.show_cookies_policy = false;
    },
  },
};
</script>

<style lang="stylus">

.gw-nav {
  font-family: 'Roboto', Arial, Helvetica, Helvetica Neue, sans-serif;
  position: relative;
  z-index: 1000;
  -webkit-font-smoothing: antialiased;

  a {
    text-decoration: none;
  }
}
</style>
